/**
 * Drupal settings class
 * - get values/object from drupalSettings
 */
export default class DrupalSettings {
    constructor() {
        this.dSettings = window.drupalSettings;
        this.themeSelector = "urifm";
        this.pathSlicer = '/';
        this.message = false;
    }
    // Setters.
    setMessage(message) {
        this.message = message;
    }

    // Getters.
    getDrupalSettings() {
        return this.dSettings;
    }

    /**
     * Search for key in drupalSettings
     * @param settingPath (uri_fm/taxonomy_menu/wissensportal)
     * @returns {*}
     */
    getDefinedDrupalSetting(settingPath) {
        let pathArr = settingPath.split(this.pathSlicer);
        let drupalSettings = this.dSettings;
        let returnObject;

        pathArr.every((element) => {
            if (element in drupalSettings) {
                drupalSettings = drupalSettings[element];
                returnObject = drupalSettings;

                this.setMessage(`Drupal settings key ${element} have been found!`);

                return true;
            }
            else {
                this.setMessage(`Drupal settings doesn't include provided key: ${element}!`);
                returnObject = false;

                return false;
            }
        });

        return returnObject;
    }

    getMessage() {
        return this.message;
    }
}
